module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-default"
  }, [_vm._m(1), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loader"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/loader.gif"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', {
    staticClass: "box-title"
  }, [_vm._v("Users")]), _vm._v(" "), _c('div', {
    staticClass: "chart-responsive"
  }, [_c('chartjs-bar', {
    attrs: {
      "option": _vm.options,
      "height": 200,
      "datalabel": _vm.label,
      "labels": _vm.channel_labels,
      "data": _vm.channel_accounts,
      "bind": true,
      "backgroundcolor": _vm.bgcolors
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', {
    staticClass: "box-title"
  }, [_vm._v("Referrals")]), _vm._v(" "), _c('div', {
    staticClass: "chart-responsive",
    attrs: {
      "id": "user-funnel"
    }
  }, [_c('chartjs-bar', {
    attrs: {
      "option": _vm.options,
      "height": 200,
      "datalabel": _vm.label,
      "labels": _vm.channel_labels,
      "data": _vm.channel_referrals,
      "bind": true,
      "backgroundcolor": _vm.bgcolors
    }
  })], 1)])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_vm._m(2), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loader"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/loader.gif"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-group",
    attrs: {
      "id": "accordion"
    }
  }, _vm._l((_vm.hasaccounts(_vm.channels)), function(channel) {
    return _c('div', [_c('div', {
      staticClass: "panel box box-primary"
    }, [_c('div', {
      staticClass: "box-header with-border"
    }, [_c('h4', {
      staticClass: "box-title"
    }, [_c('a', {
      staticClass: "collapsed",
      attrs: {
        "data-toggle": "collapse",
        "data-parent": "#accordion",
        "href": '#' + channel.channel,
        "aria-expanded": "false"
      }
    }, [_vm._v("\n                        " + _vm._s(channel.channel) + "\n                      ")])]), _vm._v(" "), _c('span', {
      staticClass: "pull-right-container h4"
    }, [_c('small', {
      staticClass: "label pull-right bg-blue"
    }, [_vm._v(_vm._s(channel.referrals))]), _vm._v(" "), _c('small', {
      staticClass: "label pull-right bg-yellow"
    }, [_vm._v(_vm._s(channel.accounts))])])]), _vm._v(" "), _c('div', {
      staticClass: "panel-collapse collapse",
      staticStyle: {
        "height": "0px"
      },
      attrs: {
        "id": channel.channel,
        "aria-expanded": "false"
      }
    }, [_c('div', {
      staticClass: "box-body"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-8"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('h5', {
      staticClass: "box-title"
    }, [_vm._v("Users")]), _vm._v(" "), _c('div', {
      staticClass: "chart-responsive"
    }, [_c('chartjs-bar', {
      attrs: {
        "option": _vm.options,
        "datalabel": channel.channel,
        "labels": channel.keywords.filter(function (keyword) { return keyword.accounts > 0; }).map(function (keyword) { return keyword.keyword; }),
        "data": channel.keywords.filter(function (keyword) { return keyword.accounts > 0; }).map(function (keyword) { return keyword.accounts; }),
        "bind": true,
        "backgroundcolor": _vm.bgcolors
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('h5', {
      staticClass: "box-title"
    }, [_vm._v("Referrals")]), _vm._v(" "), _c('div', {
      staticClass: "chart-responsive"
    }, [_c('chartjs-bar', {
      attrs: {
        "option": _vm.options,
        "datalabel": channel.channel,
        "labels": channel.keywords.filter(function (keyword) { return keyword.accounts > 0; }).map(function (keyword) { return keyword.keyword; }),
        "data": channel.keywords.filter(function (keyword) { return keyword.accounts > 0; }).map(function (keyword) { return keyword.referrals; }),
        "bind": true,
        "backgroundcolor": _vm.bgcolors
      }
    })], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('table', {
      staticClass: "table table-bordered table-striped"
    }, [_vm._m(3, true), _vm._v(" "), _c('tbody', _vm._l((_vm.hasaccounts(channel.keywords)), function(keyword) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(keyword.keyword))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(keyword.accounts))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(keyword.referrals))])])
    }))])])])])])])])])])
  }))]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      Channels\n    ")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', [_vm._v("Dashboard")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Channels")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Channel Summary")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Channel Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Keyword")]), _vm._v(" "), _c('th', [_vm._v("Users")]), _vm._v(" "), _c('th', [_vm._v("Referrals")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-39627aa1","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/keyword/KeywordChannels.vue
// module id = 6prj
// module chunks = 1